module.exports = __webpack_public_path__ + "img/IMG_1231_L_WoodMatted.34530ea8.jpg";